/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645464169582,
	"notificationDetails": {"updateType":"RESTART_TRADE_PLAN","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "RESTART_TRADE_PLAN",
	"statusDetails": {"minutesInTradePlan":2,"numberOfTrades":5,"restartAttempts":3,"realizedPnl":25.5,"isDeactivated":true},
	"date": "2022-02-21T12:22:50.668-0500",
	"timestamp": "1645464170669"
}

 * @param {*} statusDetails 
 * @returns  an object with fields:
 * 1) minutesInTradePlan:
 * 2) numberOfTrades: how many trades has the trade plan taken place in?
 * 3) restartAttempts: how many attempts has the trade plan been restarted?
 * 4) isDeactivated: is the restarted trade plan deactivated
 * 5) realizedPnl: realized Pnl so far of restarting trade plan
 */
export function restartTradePlanParser(statusDetails) {
  const parsedObj = {
    minutesInTradePlan: null,
    numberOfTrades: null,
    restartAttempts: null,
    isDeactivated: null,
    realizedPnl: null,
  };
  if (statusDetails) {
    parsedObj.minutesInTradePlan = statusDetails.minutesInTradePlan ?? null;
    parsedObj.numberOfTrades = statusDetails.numberOfTrades ?? null;
    parsedObj.restartAttempts = statusDetails.restartAttempts ?? null;
    parsedObj.isDeactivated = statusDetails.isDeactivated ?? null;
    parsedObj.realizedPnl = statusDetails.realizedPnl ?? null;
  }

  return parsedObj;
}
